import React from "react"
import { Link } from "react-router-dom"

export default function Branding() {
    return (
        <div className="page">



        <div className="row">
            <div className="col-6">
                {/* Text */}
                <div className="row">
                    <div className="col-8">
                        <h1>Primary Header</h1>
                    </div>
                    <div className="col-4">
                        <small>28px | Weight: 500</small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-8">
                        <h2>Secondary Header</h2>
                    </div>
                    <div className="col-4">
                        <small>24px | Weight: 400</small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-8">
                        <h3>Tertiary Header</h3>
                    </div>
                    <div className="col-4">
                        <small>22px | Weight: 300</small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-8">
                        <p>Normal Text - 16px / Normal</p>
                    </div>
                    <div className="col-4">
                        <small>24px | Weight: 600</small><br/>
                        <small>Font: Verdana</small>
                    </div>
                </div>

                {/* Colours */}

                {/* Primary */}
                <div className="row" style={{marginTop: 40}}>
                    <div className="col-8">
                        <div className="primary" style={{height: 25}}>&nbsp;</div>
                    </div>
                    <div className="col-4">
                        <small>#FD64C3</small>
                    </div>
                </div>
                {/* Secondary */}
                <div className="row" style={{marginTop: 10}}>
                    <div className="col-8">
                        <div className="secondary" style={{height: 25}}>&nbsp;</div>
                    </div>
                    <div className="col-4">
                        <small>#A6A6A6</small>
                    </div>
                </div>
                {/* Tertiary */}
                <div className="row" style={{marginTop: 10}}>
                    <div className="col-8">
                        <div className="tertiary" style={{height: 25}}>&nbsp;</div>
                    </div>
                    <div className="col-4">
                        <small>#000000</small>
                    </div>
                </div>
                
                {/* Dialog */}
                <div className="dialog" style={{marginTop: 40}}>
                    <h3>This is a dialog</h3>
                    <p>Body text to inform user about action in progress</p>

                    <div className="dialogButtons">
                        <button className="btn btn-secondary">Cancel</button>
                        <button className="btn btn-primary">OK</button>
                    </div>
                </div>
            </div>

            <div className="col-6">
                {/* Components */}

                {/* Textbox */}
                <div class="form-group">
                    <label>Textbox</label>
                    <input type="text" class="form-control" placeholder="Type here..." />
                    <small class="form-text text-muted">Form control helper text example</small>
                </div>

                {/* Dropdown */}
                <div class="form-group">
                    <label>Dropdown</label>
                    <div className="select">
                        <select class="form-control" placeholder="Type here..." >
                            <option>Option 1</option>
                            <option>Option 2</option>
                            <option>Option 3</option>
                        </select>
                    </div>
                </div>

                {/* Checkbox */}
                <div className="row">
                    <div className="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="0" id="check1" />
                            <label class="form-check-label" for="check1">
                                Check Box
                            </label>
                        </div>
                    </div>
                    <div className="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" id="check2" checked/>
                            <label class="form-check-label" for="check2">
                                Check Box Checked
                            </label>
                        </div>
                    </div>
                </div>
                
                {/* Radio Buttons */}
                <div className="row">
                    <div className="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" value="0" id="radio1" />
                            <label class="form-check-label" for="radio1">
                                Radio Button
                            </label>
                        </div>
                    </div>
                    <div className="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" value="1" id="radio2" checked/>
                            <label class="form-check-label" for="radio2">
                                Radio Button Checked
                            </label>
                        </div>
                    </div>
                </div>

                {/* Buttons */}
                <div className="row" style={{marginTop: 20}}>
                    <div className="col-4">
                        <button className="btn btn-primary">Primary</button>
                    </div>
                    <div className="col-4">
                        <button className="btn btn-secondary">Secondary</button>
                    </div>
                    <div className="col-4">
                        <button className="btn btn-other">Other</button>
                    </div>
                    
                </div>

                {/* Alerts */}
                <div className="row" style={{marginTop: 20}}>
                    <div className="alert alert-primary">Information Alert</div>
                    <div className="alert alert-success">Success Alert</div>
                    <div className="alert alert-warning">Warning Alert</div>
                    <div className="alert alert-danger">Danger Alert</div>
                </div>
            </div>
        </div>
                



        </div>
                
               




    
  )
}
